import { useEffect } from 'react';
import RatingSelector, { ratingOptions } from './RatingSelector.jsx';

export default function ProofLightbox({ image, images, onClose, onSelect, onRate, admin = false }) {
  useEffect(() => {
    if (!image) return undefined;

    function onKeyDown(event) {
      const currentIndex = images.findIndex((item) => item.id === image.id);
      if (event.key === 'Escape') onClose();
      if (event.key === 'ArrowRight') onSelect(images[(currentIndex + 1) % images.length]);
      if (event.key === 'ArrowLeft') onSelect(images[(currentIndex - 1 + images.length) % images.length]);
      const option = ratingOptions.find((rating) => rating.key === event.key);
      if (option) onRate(image, option.value);
      if (event.key === '0') onRate(image, null);
    }

    document.addEventListener('keydown', onKeyDown);
    document.body.classList.add('is-lightbox-open');
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.classList.remove('is-lightbox-open');
    };
  }, [image, images, onClose, onRate, onSelect]);

  if (!image) return null;

  const index = images.findIndex((item) => item.id === image.id);

  return (
    <div className="proof-lightbox" role="dialog" aria-modal="true">
      <button className="proof-lightbox__close" type="button" onClick={onClose}>
        Close
      </button>
      <div className="proof-lightbox__stage">
        <button
          className="proof-lightbox__nav proof-lightbox__nav--prev"
          type="button"
          onClick={() => onSelect(images[(index - 1 + images.length) % images.length])}
        >
          Prev
        </button>
        <img src={image.previewSrc} alt={image.filename} />
        <button
          className="proof-lightbox__nav proof-lightbox__nav--next"
          type="button"
          onClick={() => onSelect(images[(index + 1) % images.length])}
        >
          Next
        </button>
      </div>
      <aside className="proof-lightbox__panel">
        <p className="mono-label">
          {String(index + 1).padStart(2, '0')} / {String(images.length).padStart(2, '0')}
        </p>
        <h2>{image.filename}</h2>
        <RatingSelector value={image.rating} onChange={(rating) => onRate(image, rating)} />
        <p>Keys: 1 Rot / 2 Gelb / 3 Grün / 4 Final / 0 Reset</p>
        {admin && (
          <a href={`${image.originalSrc}?download=1`} target="_blank" rel="noreferrer">
            Original öffnen
          </a>
        )}
      </aside>
    </div>
  );
}
